import React from 'react'

function Input({type, placeholder, onChange, classNames, value, name, id, disabled}) {
	return (
		<input disabled={disabled ? disabled : false} type={type ? type : 'text'} className={`form-control ${classNames}`} name={name} id={id} value={value} placeholder={placeholder} onChange={onChange}/>
	)
}

export default Input
